export const BASE_URL = 'https://dev-v5.leadingquality.com';
export const USER_LEVEL = {
  director: 'Director',
  generalManager: 'General Manager',
  departmentManager: 'Department Manager',
  teamLead: 'Team Lead',
  staff: 'Staff',
};
export const SUPPORT_URL = 'support@myLQA.com';
export const DEFAULT_VIEW = [
  {
    brandId: 26,
    defaultCustomScoreNumber: 1,
    defaultScoreType: [
      {
        customScoreNumber: 1,
        customScoreName: 'Legendary Quality Experience',
      },
    ],
  },
];

export const HTTP_CODE = {
  methodNotAllowed: 405,
  forbiddenCode: 403,
  unauthorized: 401,
};
export const WORKER_URL =
  'https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js';

export const SCORING_TYPES = {
  MET: 1,
  NOT_MET: 0,
  NA: null,
};

export const imageFileTypes = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'webp',
  'svg',
];
export const audioFileTypes = ['mp3', 'wav', 'ogg', 'm4a', 'flac', 'aac'];

export const EMOTIONAL_INTELLIGENCE_SCORE = [
  {
    rating: {
      value: 1,
      label: 'Extremely dissatisfied with emotional engagement',
    },
    indicator: [
      { value: 'Ignored', label: 'Ignored' },
      { value: 'Stressed', label: 'Stressed' },
      { value: 'Frustrated', label: 'Frustrated' },
    ],
  },
  {
    rating: {
      value: 2,
      label: 'Dissatisfied with emotional engagement',
    },
    indicator: [
      { value: 'Disinterested', label: 'Disinterested' },
      { value: 'Disconnected', label: 'Disconnected' },
      { value: 'Disappointed', label: 'Disappointed' },
    ],
  },
  {
    rating: {
      value: 3,
      label: 'Engaged',
    },
    indicator: [
      { value: 'Respected', label: 'Respected' },
      { value: 'Understood', label: 'Understood' },
      { value: 'Content', label: 'Content' },
    ],
  },
  {
    rating: {
      value: 4,
      label: 'Positively engaged',
    },
    indicator: [
      { value: 'Delighted', label: 'Delighted' },
      { value: 'Appreciated', label: 'Appreciated' },
      { value: 'Individual', label: 'Individual' },
    ],
  },
  {
    rating: {
      value: 5,
      label: 'Completely engaged',
    },
    indicator: [
      { value: 'Pampered', label: 'Pampered' },
      { value: 'Special', label: 'Special' },
      { value: 'Indulged', label: 'Indulged' },
    ],
  },
];

export const patternAudio = /audio-*/;
export const patternImage = /image-*/;
